const __default__ = {
  name: "PreviewModal",
  title: "お知らせプレビュー"
};
import { computed } from "vue";
import { useStore } from "vue2-helpers/vuex";
import moment from "moment";
import UrlToLink from "@/components/common/UrlToLink.vue";
export default /*#__PURE__*/Object.assign(__default__, {
  props: {
    message: {
      type: Object,
      default: () => {}
    },
    enquete: {
      type: Object,
      default: () => {}
    },
    processReviewing: {
      type: Boolean,
      default: false
    },
    approvalMode: {
      type: Boolean,
      default: false
    },
    requesterName: {
      type: String,
      default: ""
    }
  },

  setup(__props) {
    const props = __props; // @ts-check

    const store = useStore();
    const me = computed(() => store.state.me);
    const school = computed(() => store.state.school);
    const enqueteEnd = computed(() => props.enquete?.implement_to && moment(props.enquete.implement_to).isValid() ? moment(props.enquete.implement_to).format("llll") : "");
    return {
      __sfc: true,
      props,
      store,
      me,
      school,
      enqueteEnd,
      UrlToLink
    };
  }

});